import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "pt-6",
  style: {"white-space":"pre-line"}
}
const _hoisted_2 = { class: "flex capitalize mt-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "border-t pb-3 border-gray-lp-400" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressiveCommissionConfigurationProgram = _resolveComponent("ProgressiveCommissionConfigurationProgram")!
  const _component_ProgressiveCommissionConfigurationApplied = _resolveComponent("ProgressiveCommissionConfigurationApplied")!
  const _component_ProgressiveCommissionConfigurationCalculation = _resolveComponent("ProgressiveCommissionConfigurationCalculation")!
  const _component_ProgressiveCommissionConfigurationMilestone = _resolveComponent("ProgressiveCommissionConfigurationMilestone")!
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CreateUpdate = _resolveComponent("CreateUpdate")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.id.toString(),
    loading: _ctx.isLoading,
    error: !!_ctx.errorCause,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetailData
  }, {
    data: _withCtx(() => [
      _createVNode(_component_ProgressiveCommissionConfigurationProgram, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
      _createVNode(_component_ProgressiveCommissionConfigurationApplied, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
      _createVNode(_component_ProgressiveCommissionConfigurationCalculation, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
      _createVNode(_component_ProgressiveCommissionConfigurationMilestone, {
        milestones: _ctx.detailData.mileStones
      }, null, 8, ["milestones"]),
      _createVNode(_component_DataWrapper, { class: "w-full pr-6 pt-2" }, {
        label: _withCtx(() => [
          _createVNode(_component_Title, { label: "Syarat & Ketentuan" })
        ]),
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, _toDisplayString(_ctx.detailData.termAndCondition), 1)
        ]),
        _: 1
      })
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, {
        class: "w-full",
        label: "Status Program"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", {
              class: _ctx.onChipStatus(_ctx.detailData.status)
            }, _toDisplayString(_ctx.startCase(_ctx.detailData.status)), 3)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_CreateUpdate, {
        "updated-by": _ctx.detailData.updatedBy,
        "updated-at": _ctx.formatDate(_ctx.detailData.updatedAt),
        "created-by": _ctx.detailData.createdBy,
        "created-at": _ctx.formatDate(_ctx.detailData.createdAt)
      }, null, 8, ["updated-by", "updated-at", "created-by", "created-at"]),
      _hoisted_3,
      (_ctx.isEditAble)
        ? (_openBlock(), _createBlock(_component_LpButton, {
            key: 0,
            title: "Ubah",
            onClick: _ctx.goToEdit,
            "custom-class": "w-32",
            textColor: "white"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}